import { InfoCircleOutlined } from "@ant-design/icons";
import { useLazyQuery } from "@apollo/client";
import { Button, Checkbox, Col, Drawer, Row, Tooltip } from "antd";
import { toJpeg } from "html-to-image";
import moment from "moment";
import { useQRCode } from "next-qrcode";
import React, { useCallback, useEffect, useRef } from "react";
import logo from "../../../Assets/Images/logo.png";
import placeholder from "../../../Assets/Images/placeholder.jpg";
import { GET_SINGLE_TASK_DETAILS } from "../../../Graphql/queries";
import { Loader } from "../../Loader/Loader";
import { CustIcon } from "../../Svgs";

import "./TaskQrCodeModal.css";

const { REACT_APP_ASSETS_URL } = process.env;

const TaskQrCodeModal = ({
  userTaskId,
  showQrDrawer,
  setShowQrDrawer,
  userPermission,
}) => {
  const { Canvas } = useQRCode();
  const ref = useRef();
  const [
    get_single_task_details,
    { data: taskDetails, loading: isLoadingTaskDetails },
  ] = useLazyQuery(GET_SINGLE_TASK_DETAILS, {
    variables: {
      user_task_id: userTaskId,
    },
  });
  useEffect(() => {
    get_single_task_details({
      variables: {
        user_task_id: userTaskId,
      },
    });
  }, []);

  const onCloseQrDrawer = () => {
    setShowQrDrawer(false);
  };
  const taskDetail = taskDetails?.user_tasks_map[0];
  const onDownloadImage = useCallback(() => {
    if (ref.current === null) {
      return;
    }
    toJpeg(ref.current, {
      cacheBust: true,
      quality: 1,
      canvasWidth: 1002,
      canvasHeight: 1336,
    })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = `${taskDetail?.task_id}.jpg`;
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  }, [ref, taskDetail]);

  const onDownloadFile = async (imageSrc, userTaskId) => {
    const image = await fetch(imageSrc);
    const imageBlog = await image.blob();
    const imageURL = await URL.createObjectURL(imageBlog);

    const link = document.createElement("a");
    link.href = imageURL;
    link.download = userTaskId;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Drawer
      placement="right"
      // closable={false}
      width={720}
      maskStyle={{ backgroundColor: "#000000CC" }}
      title="Task details"
      onClose={onCloseQrDrawer}
      visible={showQrDrawer}
    >
      {isLoadingTaskDetails ? (
        <Loader className="full_screen" />
      ) : (
        <div className="qrModalSection">
          <div className={`${taskDetail?.task?.task_type} taskDetailsSection`}>
            {/* <h5>{taskDetail.task_type.replace(/_/g,' ')}</h5> */}
            <h5>{taskDetail?.task?.taskTypeByTaskType?.type_name}</h5>
            <p>{taskDetail?.task?.description}</p>
          </div>
          {taskDetail?.task_status === "pending" && userPermission ? (
            <div className="taskQRsection">
              <div className="qrCodeSection">
                <Canvas
                  text={`user_id: ${taskDetail?.user?.user_id}, task_id: ${taskDetail?.task_id}`}
                  options={{
                    type: "image/jpeg",
                    quality: 1,
                    level: "H",
                    margin: 0,
                    scale: 1,
                    width: 150,
                    color: {
                      light: "#ffffff",
                    },
                  }}
                />
              </div>
              <div className="qrCodeDownload">
                <Button type="seconday" shape="round" onClick={onDownloadImage}>
                  <CustIcon type="download" className="mr-2" />
                  Download
                </Button>
              </div>
            </div>
          ) : null}

          <div className="assignedSection">
            <h5>Assigned to</h5>
            <Row>
              <Col md={12} xs={24}>
                <h6>{taskDetail?.user?.full_name}</h6>
                <p>{moment(taskDetail?.task_date).format("MM/DD/YYYY")}</p>
              </Col>
              <Col md={12} xs={24} className="text-md-right pt-md-0 pt-3">
                <p className="mb-1">
                  {
                    taskDetail?.user?.user_location_maps[0]?.jobRoleDetails
                      ?.role_name
                  }
                </p>
                <div className="location">
                  <CustIcon type="location" className="mr-2" />
                  <span>
                    {taskDetail?.user?.user_location_maps.map(
                      (location, index) => {
                        return (
                          <span key={index}>
                            {location?.locationDetails?.street_address},{" "}
                            {location?.locationDetails?.location_name}
                          </span>
                        );
                      }
                    )}
                  </span>
                </div>
              </Col>
              {taskDetail?.required_attachment && (
                <Col md={24} xs={24} className="pt-3 d-flex align-items-center">
                  <Checkbox defaultChecked disabled></Checkbox>
                  <div className="pl-2 pt-1">
                    Picture Attestation Required?{" "}
                    <Tooltip
                      placement="topRight"
                      title="Employee needs to upload the proof of attestation when the task is completed"
                    >
                      <InfoCircleOutlined />
                    </Tooltip>
                  </div>
                </Col>
              )}
            </Row>
          </div>
          {!(taskDetail?.task_status === "pending") && (
            <div className="assignedSection">
              <h5>
                {taskDetail?.task_status === "completed" &&
                  taskDetail?.userByTaskStatusUpdatedBy &&
                  "Completed by"}
                {taskDetail?.task_status === "completed" &&
                  !taskDetail?.userByTaskStatusUpdatedBy &&
                  "Completed by"}
                {taskDetail?.task_status === "incomplete" &&
                  taskDetail?.userByTaskStatusUpdatedBy &&
                  "Not completed by"}
                {taskDetail?.task_status === "escalated" && "Escalated by"}
              </h5>
              <Row>
                <Col md={12} xs={24}>
                  <h6>
                    {!!taskDetail?.userByTaskStatusUpdatedBy
                      ? taskDetail?.userByTaskStatusUpdatedBy?.full_name
                      : taskDetail?.user?.full_name}
                  </h6>
                  <p>
                    {!!taskDetail?.task_status_updated_at
                      ? moment(taskDetail?.task_status_updated_at).format(
                          "MM/DD/YYYY hh:mm A"
                        )
                      : moment(taskDetail?.updated_at).format(
                          "MM/DD/YYYY hh:mm A"
                        )}
                  </p>
                </Col>
                <Col md={12} xs={24} className="text-md-right pt-md-0 pt-3">
                  <p className="mb-1">
                    {!!taskDetail?.userByTaskStatusUpdatedBy
                      ? taskDetail?.userByTaskStatusUpdatedBy
                          ?.user_location_maps[0]?.jobRoleDetails?.role_name
                      : taskDetail?.user?.user_location_maps[0]?.jobRoleDetails
                          ?.role_name}
                  </p>
                  <div className="location">
                    <CustIcon type="location" />{" "}
                    {!!taskDetail?.userByTaskStatusUpdatedBy
                      ? taskDetail?.userByTaskStatusUpdatedBy?.user_location_maps.map(
                          (location, index) => {
                            return (
                              <span key={index}>
                                {location?.locationDetails?.street_address},{" "}
                                {location?.locationDetails?.location_name}
                              </span>
                            );
                          }
                        )
                      : taskDetail?.user?.user_location_maps.map(
                          (location, index) => {
                            return (
                              <span key={index}>
                                {location?.locationDetails?.street_address},{" "}
                                {location?.locationDetails?.location_name}
                              </span>
                            );
                          }
                        )}
                  </div>
                </Col>
              </Row>
              {!!taskDetail?.task_files && !!taskDetail?.task_files.length && (
                <div className="reason">
                  <div className="border"></div>
                  <h5>Uploaded pictures by employee</h5>
                  <Row gutter={30}>
                    {taskDetail?.task_files.map((file, index) => {
                      return (
                        <Col xxl={8} sm={8} xs={24} key={index}>
                          <div className="picUploaded mb-sm-0 mb-3">
                            <img
                              src={
                                file.file_name.includes("https")
                                  ? file.file_name
                                  : REACT_APP_ASSETS_URL + file.file_name
                              }
                              alt=""
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = placeholder;
                              }}
                              className="w-100"
                              // onLoad={(e) => {
                              //   e.target.src = loadingImg;
                              // }}
                            />

                            <div
                              className="download"
                              onClick={() => {
                                let url = file.file_name.includes("https")
                                  ? file.file_name
                                  : REACT_APP_ASSETS_URL + file.file_name;
                                onDownloadFile(url, userTaskId + "_" + index);
                              }}
                            >
                              <CustIcon type="download" />
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              )}
            </div>
          )}

          {taskDetail?.task?.user_tasks_maps[0]?.note && (
            <div className="assignedSection">
              <h5>Reason</h5>
              <p>{taskDetail?.task?.user_tasks_maps[0]?.note}</p>
            </div>
          )}
          <div className="printSec">
            <div className="qrPrint" ref={ref}>
              <div className="logoSection">
                <img src={logo} alt="" />
              </div>
              <div className="contentSec">
                <div className="title">
                  <h5>
                    This QR code is meant for internal purpose. If you are an
                    employee, please scan this QR code to mark the task
                    complete!
                  </h5>
                </div>
                {taskDetail?.task_status === "pending" ? (
                  <div className="taskQRsection mb-0">
                    <div className="qrCodeSection mb-0">
                      <Canvas
                        text={`user_id: ${taskDetail?.user?.user_id}, task_id: ${taskDetail?.task_id}`}
                        options={{
                          type: "image/jpeg",
                          quality: 1,
                          level: "H",
                          margin: 0,
                          scale: 1,
                          width: 190,
                          color: {
                            light: "#ffffff",
                          },
                        }}
                      />
                    </div>
                  </div>
                ) : null}
                <div className="footer">
                  <span>
                    *This QR is meant for organizational internal purpose of
                    practicing cleanliness and sanitization activities -
                    SanAttest
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Drawer>
  );
};

export default TaskQrCodeModal;
